import React, { useState } from 'react'
import Slides from '../slides/Slides'
import Card from './Card'
import Casemi from './Casemi'
import DividingBar from './DividingBar'
import Footer from '../footer/Footer'
import MinDesEcoPro from './MinDesEcoPro'
import Blog from './Blog'
import Capacitacion from './Capacitacion'
import BancoMacro from './BancoMacro'
import Srt from './Srt'
import MsjHome from './MsjHome'
import Clientes from './Clientes'
import Contactanos from './Contactanos'
import Preloader from './Preloader'
import Instagram from './Instagram'
import LinkedIn from './LinkedIn'
import Modal from './Modal'
import ModalClientes from './ModalClientes'
import FaceBook from './FaceBook'


const Home = ({M}) => {
   const [modalHome,setModalHome]          = useState('modal-show');
   const [modalClientes, setModalClientes] = useState('');
   window.addEventListener("click", function (e) {
      setModalHome('');
   });
   
   return (
      <> 
         <Slides M={M} tipoSlides={"home"} setModalClientes={setModalClientes}/>
         <Card/>
         <Casemi M={M}/>
         <DividingBar/>
         <MinDesEcoPro/>
         <DividingBar/>
         <Blog/>
         <DividingBar/>
         <Capacitacion/>
         <DividingBar/>
         <BancoMacro/>
         <DividingBar/>
         <Srt/>
         <DividingBar/>
         <MsjHome/>
         <Clientes/>
         <DividingBar/>
         <Contactanos/>
         <DividingBar/>
         <DividingBar/>
         <FaceBook/>
         <Instagram/>
         <LinkedIn/>
         {/* <Modal M={M} modalHome={modalHome}/> */}
         <ModalClientes modalClientes={modalClientes} setModalClientes={setModalClientes}/>
         {/* <Preloader/> */}
      </>
   )
}

export default Home